import api from 'data/api';

export const loadCreatedBy = api('GET /api/mobile/finance/lookups/creators');
